<app-icon-download
	*ngIf="!isAP && isResultSuccess"
	class="grid-outer-header__action-icon"
	[ngClass]="{ loading: loading }"
	[iconCls]="'icon--light'"
	matTooltip="Export"
	(click)="downloadInvoice()"
></app-icon-download>
